import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import languageOptionEN from "./en/languageoption.json";
import MainNavigationEN from "./en/mainnavigation.json";
import HomeEN from "./en/home.json";
import ServicesEN from "./en/services.json";
import ErrorEN from "./en/error.json";
import LoginEN from "./en/login.json";
import loginFormEN from "./en/loginform.json";
import InstallationLandingEN from "./en/installationlandingen.json";
import ActiveServicesEN from "./en/activeservices.json";
import DocumentsTableEN from "./en/documentstable.json";
import footerEN from "./en/footer.json";
import NavigationEn from "./en/navigation.json";
import yusoappsEN from "./en/yusoapps.json";
import SelectCompanyEN from "./en/selectcompany.json";
import AddCompanyEN from "./en/addcompany.json";
import serviceDashboardEN from "./en/servicedashboard.json";
import addserviceEN from "./en/addservice.json";
import managementEN from "./en/management.json";
import bessresignEN from "./en/bessresign.json";
import pvcurtailmentEN from "./en/pvcurtailment.json";
import bessOnboardingEN from "./en/bessOnboarding.json";
import permalinksEN from "./en/permalinks.json";

import languageOptionFR from "./fr/languageoption.json";
import MainNavigationFR from "./fr/mainnavigation.json";
import HomeFR from "./fr/home.json";
import ServicesFR from "./fr/services.json";
import ErrorFR from "./fr/error.json";
import LoginFR from "./fr/login.json";
import loginFormFR from "./fr/loginform.json";
import InstallationLandingFR from "./fr/installationlandingfr.json";
import ActiveServicesFR from "./fr/activeservices.json";
import DocumentsTableFR from "./fr/documentstable.json";
import footerFR from "./fr/footer.json";
import NavigationFr from "./fr/navigation.json";
import yusoappsFR from "./fr/yusoapps.json";
import SelectCompanyFR from "./fr/selectcompany.json";
import AddCompanyFR from "./fr/addcompany.json";
import serviceDashboardFR from "./fr/servicedashboard.json";
import addserviceFR from "./fr/addservice.json";
import managementFR from "./fr/management.json";
import bessresignFR from "./fr/bessresign.json";
import pvcurtailmentFR from "./fr/pvcurtailment.json";
import bessOnboardingFR from "./fr/bessOnboarding.json";
import permalinksFR from "./fr/permalinks.json";

import languageOptionNL from "./nl/languageoption.json";
import MainNavigationNL from "./nl/mainnavigation.json";
import HomeNL from "./nl/home.json";
import ServicesNL from "./nl/services.json";
import ErrorNL from "./nl/error.json";
import LoginNL from "./nl/login.json";
import loginFormNL from "./nl/loginform.json";
import InstallationLandingNL from "./nl/installationlandingnl.json";
import ActiveServicesNL from "./nl/activeservices.json";
import DocumentsTableNL from "./nl/documentstable.json";
import footerNL from "./nl/footer.json";
import NavigationNL from "./nl/navigation.json";
import yusoappsNL from "./nl/yusoapps.json";
import SelectCompanyNL from "./nl/selectcompany.json";
import AddCompanyNL from "./nl/addcompany.json";
import serviceDashboardNL from "./nl/servicedashboard.json";
import addserviceNL from "./nl/addservice.json";
import managementNL from "./nl/management.json";
import bessresignNL from "./nl/bessresign.json";
import pvcurtailmentNL from "./nl/pvcurtailment.json";
import bessOnboardingNL from "./nl/bessOnboarding.json";
import permalinksNL from "./nl/permalinks.json";

const resources = {
  en: {
    languageOption: languageOptionEN,
    MainNavigation: MainNavigationEN,
    Home: HomeEN,
    Services: ServicesEN,
    Error: ErrorEN,
    Login: LoginEN,
    LoginForm: loginFormEN,
    InstallationLanding: InstallationLandingEN,
    ActiveServices: ActiveServicesEN,
    DocumentsTable: DocumentsTableEN,
    footer: footerEN,
    navigation: NavigationEn,
    Yusoapps: yusoappsEN,
    SelectCompany: SelectCompanyEN,
    AddCompany: AddCompanyEN,
    serviceDashboard: serviceDashboardEN,
    addservice: addserviceEN,
    management: managementEN,
    bessresign: bessresignEN,
    pvcurtailment: pvcurtailmentEN,
    bessOnboarding: bessOnboardingEN,
    permalinks: permalinksEN,
  },
  fr: {
    languageOption: languageOptionFR,
    MainNavigation: MainNavigationFR,
    Home: HomeFR,
    Services: ServicesFR,
    Error: ErrorFR,
    Login: LoginFR,
    LoginForm: loginFormFR,
    InstallationLanding: InstallationLandingFR,
    ActiveServices: ActiveServicesFR,
    DocumentsTable: DocumentsTableFR,
    footer: footerFR,
    navigation: NavigationFr,
    Yusoapps: yusoappsFR,
    SelectCompany: SelectCompanyFR,
    AddCompany: AddCompanyFR,
    serviceDashboard: serviceDashboardFR,
    addservice: addserviceFR,
    management: managementFR,
    bessresign: bessresignFR,
    pvcurtailment: pvcurtailmentFR,
    bessOnboarding: bessOnboardingFR,
    permalinks: permalinksFR,
  },
  nl: {
    languageOption: languageOptionNL,
    MainNavigation: MainNavigationNL,
    Home: HomeNL,
    Services: ServicesNL,
    Error: ErrorNL,
    Login: LoginNL,
    LoginForm: loginFormNL,
    InstallationLanding: InstallationLandingNL,
    ActiveServices: ActiveServicesNL,
    DocumentsTable: DocumentsTableNL,
    footer: footerNL,
    navigation: NavigationNL,
    Yusoapps: yusoappsNL,
    SelectCompany: SelectCompanyNL,
    AddCompany: AddCompanyNL,
    serviceDashboard: serviceDashboardNL,
    addservice: addserviceNL,
    management: managementNL,
    bessresign: bessresignNL,
    pvcurtailment: pvcurtailmentNL,
    bessOnboarding: bessOnboardingNL,
    permalinks: permalinksNL,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  debug: true,
  ns: [
    "languageOption",
    "MainNavigation",
    "Home",
    "Services",
    "Error",
    "Login",
    "LoginForm",
    "InstallationLanding",
    "ActiveServices",
    "DocumentsTable",
    "footer",
    "navigation",
    "Yusoapps",
    "SelectCompany",
    "AddCompany",
    "serviceDashboard",
    "addservice",
    "management",
    "bessresign",
    "pvcurtailment",
    "bessOnboarding",
    "permalinks",
  ],
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
